module.exports = __webpack_public_path__ + "static/media/item3.d678fa4e.png";